import catalogModule from '../catalogModule';
import menuConstants from '../constants/menuConstants';

function itemsContainerController($log, $scope, catalogConstants) {
  'ngInject';

  $scope.getNumberItemToDisplay = () => {
    if ($scope.library.isFullScreen) {
      return catalogConstants.numberOfSearchItemsForFullScreen;
    }
    const { isSplashPage } = $scope.library;
    return isSplashPage ? catalogConstants.numberOfSearchItems : $scope.searchResultList.length;
  };

  $scope.isInfiniteScrollEnabled = () => {
    const { initialized, isPhone } = $scope.library;
    return initialized && isPhone;
  };

  $scope.isRegularItemsResultAvailable = () => {
    const { initialized, isPhone } = $scope.library;
    return initialized && !isPhone;
  };

  $scope.isBreadcrumbsAvailable = () => {
    const { initialized, isPhone } = $scope.library;
    return initialized && !isPhone;
  };

  $scope.shouldShowHeading = () => {
    return ($scope.layout.isNavigationMenuLoaded &&
      ($scope.library.isSplashPage || $scope.isCurrentCategoryRecommended())
    );
  };

  $scope.isRecommendedEnabled = () => {
    return $scope.library.defaultCategoryId === menuConstants.categoryTypes.Recommended;
  }

  $scope.showRecommendedHeading = () => {
    return ($scope.library.isSplashPage && $scope.isRecommendedEnabled()) ||
      $scope.isCurrentCategoryRecommended();
  }

  $scope.pager = {
    loadNextPage() {
      const { nextPageCursor, startPaging } = $scope.paginations;
      if (nextPageCursor && !startPaging) {
        $scope.queries.cursor = nextPageCursor;
        $scope.getSearchItems($scope.queries, true);
        $scope.paginations.direction = catalogConstants.pageDirection.next;
        $scope.paginations.startPaging = true;
      }
    },
    loadPreviousPage() {
      const { previousPageCursor, startPaging } = $scope.paginations;
      if (previousPageCursor && !startPaging) {
        $scope.queries.cursor = previousPageCursor;
        $scope.getSearchItems($scope.queries, true);
        $scope.paginations.direction = catalogConstants.pageDirection.prev;
        $scope.paginations.startPaging = true;
      }
    },
    canLoadNextPage() {
      const { nextPageCursor, startPaging } = $scope.paginations;
      return nextPageCursor && !startPaging;
    },
    canLoadPreviousPage() {
      const { previousPageCursor, startPaging } = $scope.paginations;
      return previousPageCursor && !startPaging;
    },
    getCurrentPageNumber() {
      return $scope.paginations.currentPage;
    }
  };
}

catalogModule.controller('itemsContainerController', itemsContainerController);

export default itemsContainerController;
